module.exports = __webpack_public_path__ + "static/media/failure.b4b8dda2.png";